const veiculoUtils = {
    getDescricaoVeiculo: (veiculo) => (veiculo.vefipe_marca.toLowerCase() + " " + veiculo.vefipe_name.toLowerCase()),
    isNovo: (tipoVeiculo) => tipoVeiculo === 'novos',
    isSeminovo: (tipoVeiculo) => tipoVeiculo === 'seminovos',
    isNovoVeiculo: (veiculo, descricaoVeiculo, filtro) => descricaoVeiculo.includes(filtro) && veiculo.vequilometragem <= 100,
    isSeminovoVeiculo: (veiculo, descricaoVeiculo, filtro) => descricaoVeiculo.includes(filtro) && veiculo.vequilometragem > 100
};

export default veiculoUtils;